import template from './editInvitationButton.template.html';

export default {
  template,
  bindings: {
    integration: '<'
  },
  controllerAs: '$ctrl',
  controller: class controller {
    constructor(
      $rootScope,
      accountService,
      accountsService,
      organizationService,
      eventService,
      mergeFieldsService,
      uiService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.isOpen = false;
      ctrl.mergeFields = [];

      ctrl.initialize = () => {
        ctrl.integration = ctrl.integration || '';
      };

      ctrl.getMergeFields = () =>
        mergeFieldsService.getFields(false).then((result) => {
          ctrl.mergeFields = result;
          return true;
        });

      ctrl.editInvitationContent = () => {
        ctrl.getMergeFields().then(() => {
          try {
            eventService.dialogTextEdit({
              id: ctrl.integration,
              title: 'Edit invitation content',
              content:
                ctrl.integration === 'idSmart'
                  ? $rootScope.CurrentOrganization.integrations[ctrl.integration]
                      ?.emailCustomContent
                  : $rootScope.CurrentAccount.integrations[ctrl.integration]
                      ?.emailCustomContent || '',
              mergeProperties: ctrl.mergeFields,
              plainText: true
            });
          } catch (e) {
            //
          }
        });
      };

      ctrl.onEditInvitationContentFinished = (result) => {
        if (result.id === 'bankStatements' || result.id === 'mogo') {
          accountsService.clearCache();
          accountService.updateAccount({
            id: $rootScope.CurrentAccount.id,
            integrations: {
              [ctrl.integration]: {
                emailCustomContent: result.content || ''
              }
            }
          });

          uiService.toast({
            text: {
              p1: 'Saving',
              p2: 'Invitation content',
              p3: 'Please wait...'
            },
            progress: true
          });

          // eslint-disable-next-line no-param-reassign
          $rootScope.CurrentAccount.integrations[ctrl.integration].emailCustomContent =
            result.content;
        } else if (result.id === 'idSmart') {
          try {
            organizationService.clearCache();
            organizationService.updateOrganization({
              id: $rootScope.CurrentOrganization.id,
              integrations: {
                [ctrl.integration]: {
                  emailCustomContent: result.content || ''
                }
              }
            });

            uiService.toast({
              text: {
                p1: 'Saving',
                p2: 'Invitation content',
                p3: 'Please wait...'
              },
              progress: true
            });

            // eslint-disable-next-line no-param-reassign
            $rootScope.CurrentOrganization.integrations[ctrl.integration].emailCustomContent =
              result.content;
          } catch (e) {
            //
          }
        }
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
